import { ETableStructureAlign, ETableStructureType, TTableStructure } from 'ui/EasTable/types';
import { EIconButtons } from 'ui/EasTable/EasTableRow/EasTableValue/constants';
import { TEasInfoTableRow } from './types';

export const GROUP_FILTER_SELECTOR = 'groupTitle';

export const tableStructure: TTableStructure<keyof TEasInfoTableRow>[] = [
	{
		name: 'ID',
		selector: 'id',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.NUMBER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Group',
		selector: 'groupTitle',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
		separateFilter: true,
		filter: [],
	},

	{
		name: 'Name of the variable',
		selector: 'name',
		show: false,
		sortable: false,
		filterable: false,
		colSpan: 2,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Name of the variable',
		selector: 'title',
		show: true,
		sortable: false,
		filterable: false,
		searchable: true,
		colSpan: 2,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		tooltip: (item) => item.title,
	},
	{
		name: 'Value',
		selector: 'value',
		show: true,
		sortable: false,
		filterable: false,
		searchable: false,
		colSpan: 2,
		type: ETableStructureType.STRING,
		align: ETableStructureAlign.LEFT,
		tooltip: (item) => item.value,
	},
	{
		name: 'Type',
		selector: 'type',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.STATUS,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Last Changed',
		selector: 'lastChanged',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.DATE_TIME,
		align: ETableStructureAlign.CENTER,
	},
	{
		name: 'Updated By',
		selector: 'updatedBy',
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 2,
		type: ETableStructureType.USER,
		align: ETableStructureAlign.LEFT,
	},
	{
		name: 'Actions',
		selector: 'actions',
		noName: true,
		show: true,
		sortable: false,
		filterable: false,
		colSpan: 1,
		type: ETableStructureType.BUTTONS,
		align: ETableStructureAlign.RIGHT,
		buttons: [
			{
				name: 'Edit',
				icon: EIconButtons.EDIT,
			},
		],
	},
];
